"use client";
import { FakeInputContainer, VerticalCenterDiv } from "../divs";
import { AlmostBoldText, LightText } from "@/common/texts";
import { NEUTRO_TITLES_COLOR } from "@/utils/constants";

export interface SearchInputWithIconProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  height?: string;
  onClick?: () => void;
}

const SearchInputWithIcon: React.FC<SearchInputWithIconProps> = (
  props: SearchInputWithIconProps,
) => {
  return (
    <FakeInputContainer
      onClick={props.onClick}
      width="100%"
      style={{ cursor: "pointer", height: props.height && props.height }}
    >
      <VerticalCenterDiv
        style={{
          textAlign: "left",
          marginLeft: "12px",
          width: "65%",
          marginTop: "-2px",
        }}
      >
        <AlmostBoldText color={NEUTRO_TITLES_COLOR} fontSize="10px">
          {props.title}
        </AlmostBoldText>
        <LightText
          color={NEUTRO_TITLES_COLOR}
          fontSize="14px"
          className="overflowOnTwoLines"
          style={{ marginTop: "-3px" }}
        >
          {props.subtitle}
        </LightText>
      </VerticalCenterDiv>
      <VerticalCenterDiv right="12px" marginY="2px">
        {props.children}
      </VerticalCenterDiv>
    </FakeInputContainer>
  );
};

export default SearchInputWithIcon;
